// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconArrowUp = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.47 16.53a.75.75 0 010-1.06l8-8a.75.75 0 011.06 0l8 8a.75.75 0 11-1.06 1.06L12 9.06l-7.47 7.47a.75.75 0 01-1.06 0z"
      fill="currentColor"
    />
  );
export default SvgIconArrowUp;
